import { SurvivalHorizonData } from '@liquitics/transaction';
import { TrendMetric } from './../trend-metric/trend-metric';
import { AmChartsService } from '@amcharts/amcharts3-angular';

export class BreachMetric extends TrendMetric {
    // private readonly RAG_COLORS = ['#c0392b', '#e67e22', '#f1c40f', '#2ecc71', '#27ae60'];
    private readonly MAX_DAYS = 180;
    daysOk = 0;
    delta = 0;
    breached = false;
    colors: string[] = [];
    chartData: any[] = [];

    chart: any;
    chartDivName: string;

    submetric1: string;
    submetric2: string;
    submetric3: string;

    constructor(metricType: string,
        name: string,
        currency: string,
        currencyIndex,
        public valueFieldExtractor: (entry: SurvivalHorizonData) => number,
        public thresholdCheck: (entry: SurvivalHorizonData) => boolean,
        public subMetricProcessor: (breach: BreachMetric, entry: SurvivalHorizonData) => void
    ) {
        super(metricType, 'breach');
        this.metricType = metricType;
        this.name = name;
        this.currency = currency;
        this.currencyIndex = currencyIndex
        this.reset();
    }

    reset() {
        this.daysOk = 0;
        this.delta = 0;
        this.breached = false;
        this.chartData = [];
        this.colors.push(TrendMetric.C_A700[TrendMetric.COLOR_COUNT - 1]);
        this.colors.push(TrendMetric.C_900[TrendMetric.COLOR_COUNT - 1]);
        this.colors.push(TrendMetric.C_300[TrendMetric.COLOR_COUNT - 1]);
    }

    process(entry: SurvivalHorizonData) {
        this.initialized = true;
        const cd = {};
        if (!this.breached) {
            if (this.thresholdCheck(entry)) {
                this.daysOk++;
                this.daysOk = (Math.min(this.MAX_DAYS, this.daysOk));
            } else {
                this.breached = true;
                this.colors = this.getBreachColors(this.daysOk, this.MAX_DAYS);
                cd['bullet'] = 'round';
            }
        }
        cd['day'] = this.chartData.length;
        cd['value'] = this.valueFieldExtractor(entry);
        this.chartData.push(cd);
        this.subMetricProcessor(this, entry);
    }

    private getBreachColors(numerator: number, denomimator: number): string[] {
        const colors: string[] = [];
        const ratio = numerator / denomimator;

        let index = Math.round((TrendMetric.COLOR_COUNT - 1) * ratio);
        index = Math.max(0, index);
        index = Math.min(TrendMetric.COLOR_COUNT - 1, index);
        colors.push(TrendMetric.C_A700[index]);
        colors.push(TrendMetric.C_900[index]);
        colors.push(TrendMetric.C_300[index]);
        return colors;
    }

    public createChart(amCharts: AmChartsService, ccyIndex: number, metricIndex: number, dataProvider: any[]): any {
        const chart = amCharts.makeChart('chart' + ccyIndex + '-' + metricIndex, {
            'type': 'serial',
            'hideCredits': true,
            'categoryField': 'day',
            'autoMargins': false,
            'marginLeft': 0,
            'marginRight': 0,
            'marginTop': 0,
            'marginBottom': 0,
            'graphs': [{
                'bulletField': 'bullet',
                'bulletColor': 'black',
                'valueField': 'value',
                'type': 'smoothedLine',
                // 'fillAlphas': 0.4,
                'fillAlphas': 1,
                // "lineColor": "#a9ec49",
                'showBalloon': false
            }],
            'valueAxes': [{
                'gridAlpha': 0,
                'axisAlpha': 0,
            }],
            'categoryAxis': {
                'gridAlpha': 0,
                'axisAlpha': 0,
                'startOnAxis': true
            },
            'guides': [
                {
                    'fillAlpha': 0.50,
                    'value': 0,
                    'lineThickness': 1,
                }
            ],
            'dataProvider': dataProvider,
        });
        return chart;
    }
}
